import { render, staticRenderFns } from "./duplicate-event.vue?vue&type=template&id=71460fe7&scoped=true"
import script from "./duplicate-event.vue?vue&type=script&lang=js"
export * from "./duplicate-event.vue?vue&type=script&lang=js"
import style0 from "./duplicate-event.vue?vue&type=style&index=0&id=71460fe7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71460fe7",
  null
  
)

export default component.exports